// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".countdown{align-items:center;display:flex;justify-content:center}.countdown__inner p{padding:0}.countdown__inner span{display:flex;position:relative}.countdown__inner span.v-leave-active{position:absolute}.countdown__separator{margin:0 .3125rem}.countdown .left{left:0}.countdown .right{right:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
